let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePMd3")).then(() => parcelRequire('3Sbqy'));